import Repository from "../Repository";
import { getAuthHeader } from "../../_helpers/apiHelper";

const resource = "/companies";

export default {
  get(user) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}`, config);
  },
  getAll(user) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/all`, config);
  },

  getCompany(user) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}`, config);
  },

  getCompanyById(user, companyId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/${companyId}`, config);
  },

  getCompanyUsers(user, companyId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/${companyId}/users`, config);
  },

  getCompanyApplications(user, companyId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/${companyId}/applications`, config);
  },

  create(user, payload) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.post(`${resource}`, payload, config);
  },

  edit(user, companyId, payload) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.put(`${resource}/${companyId}`, payload, config);
  },

  delete(user, companyId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.delete(`${resource}/${companyId}`, config);
  },

  createUser(user, companyId, userPayload) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.post(
      `${resource}/${companyId}/user`,
      userPayload,
      config
    );
  },

  postImage(user, companyId, image) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.post(`${resource}/${companyId}/image`, image, config);
  },

  deleteImage(user, companyId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.delete(`${resource}/${companyId}/image`, config);
  }
};
